import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callSecureAPI from '../../../API/callSecureAPI'
import { CommentsViewComment } from '../CommentsView.types'

const TWO_MINUTES = 1000 * 60 * 2

export const getCommentsDashboardQueryKey = (strategyId?: string) => ['commentsView', strategyId] as const

export const useGetCommentsDashboardQuery = (strategyId?: string) => {
    const { getTokenSilently, isAuthenticated } = useAuth0()

    const getCommentsDashboard = async () => {
        if (!strategyId) return []

        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const { url, method } = endpoints.getCommentsDashboard

        const response = await callSecureAPI(`${url}${strategyId}`, method, token)

        if (!response?.success) throw new Error(response?.error || 'Failed to load comments view data')

        return (response?.data || []) as CommentsViewComment[]
    }

    return useQuery<CommentsViewComment[]>(getCommentsDashboardQueryKey(strategyId), getCommentsDashboard, {
        enabled: !!strategyId && !!isAuthenticated,
        staleTime: TWO_MINUTES,
    })
}
